import React from 'react';
import { Spin as AntSpin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';
const defaultIndicator = React.createElement(LoadingOutlined, { spin: true });
const StyledSpin = styled(AntSpin) `
  .anticon,
  .ant-spin-text {
    color: var(--color-spin);
  }
`;
const StyledLoadingSpin = styled.div `
  text-align: center;
`;
export function Spin(props) {
    const { indicator = defaultIndicator } = props;
    return React.createElement(StyledSpin, Object.assign({ indicator: indicator }, props));
}
export function LoadingSpin(props) {
    return (React.createElement(StyledLoadingSpin, null,
        React.createElement(Spin, Object.assign({ size: "large" }, props))));
}
